import { toast } from "$global-providers/toast-provider";
import { defineMessage, useIntl } from "react-intl";
import useFetchPrintableInvoice from "../hooks/useFetchPrintableInvoice";
import type { PrintableLaserReceiptProps } from "../types";
import LegacyLaserReceiptPrint from "./Receipt/LaserReceiptPrint";

const ERROR_MESSAGE = defineMessage({
  id: "invoicing.getInvoice.error.msg",
  defaultMessage: "Failed to fetch this invoice",
});

// shims legacy receipt printing component to fetch full invoice details
export const PrintableLaserReceipt = ({
  invoiceId,
  onAfterPrint,
}: PrintableLaserReceiptProps) => {
  const { formatMessage } = useIntl();

  const { data, loading, error } = useFetchPrintableInvoice(invoiceId, {
    fetchPolicy: "network-only",
  });
  if (loading) {
    return null;
  }
  if (error) {
    toast.error(formatMessage(ERROR_MESSAGE));
    onAfterPrint();
    return null;
  }
  return (
    <LegacyLaserReceiptPrint
      onAfterPrint={onAfterPrint}
      invoice={data.invoice}
      printReceiptOnly
      invoicesToPrint={[]}
    />
  );
};
